import { IonCard, IonIcon, IonItem, IonLabel, IonNote, IonText } from "@ionic/react";
import { bagOutline, calendarOutline, clipboardOutline, locationOutline } from "ionicons/icons";
import { UserRole } from "../../@types/userRole";

interface ComponentProps {
  userRoles: UserRole[];
}
export const UserRolesList: React.FC<ComponentProps> = ({ userRoles }) => {
  const PrintItem = ({ userRoleItem }: any) => (
    <IonItem lines="none">
      <IonIcon icon={bagOutline} slot="start"></IonIcon>
      <IonLabel>
        <h2 style={{ fontWeight: 500 }}>{`${userRoleItem.role?.name}`}</h2>
        <p style={{ fontWeight: 500 }}>
          <IonIcon icon={locationOutline}></IonIcon>
          <span className="ion-margin-start">{userRoleItem.location?.name}</span>
          <span className="ion-margin-start"></span>
        </p>
        <p>
          <IonIcon icon={clipboardOutline}></IonIcon>
          <span className="ion-margin-start">
            Contratado por{" "}
            <span style={{ fontWeight: 500 }}>{userRoleItem.sourceOrganization?.name}</span> para{" "}
            <span style={{ fontWeight: 500 }}>{userRoleItem.organization?.name}</span>
          </span>
        </p>
      </IonLabel>
      <IonNote slot="end">
        <h3>
          <IonIcon icon={calendarOutline}></IonIcon>
          <span className="ion-margin-start">
            {userRoleItem.periodStart} - {userRoleItem.periodEnd}
          </span>
        </h3>
      </IonNote>
    </IonItem>
  );
  return (
    <>
      <h2 className="ion-padding-horizontal">
        <IonText color="primary">Relación laboral</IonText>
      </h2>
      <IonCard>
        {userRoles.length === 0 && (
          <IonItem lines="none">
            <IonLabel>
              <IonText color="medium">No se han encontrado roles</IonText>
            </IonLabel>
          </IonItem>
        )}
        {userRoles
          .filter(({ code }) => code !== "Sup. Responsable")
          .map((userRoleItem: UserRole, index) => (
            <PrintItem key={`item-${index}`} userRoleItem={userRoleItem} />
          ))}
      </IonCard>
    </>
  );
};
